module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"videoCall":"Create videocall"}}')
  delete Component.options._Ctor
}
